export class ItemCodeRequest{
    itemCode:number;
    unitId?:number;
    constructor(itemCode:number,unitId?:number){
        this.itemCode = itemCode;
        this.unitId = unitId;
    }
}